
export default function ContactSection() {
  return (
    <section id="contact" className="pt-20 md:pt-36 pb-20 md:pb-40 bg-white">
      <div className="max-w-[1400px] mx-auto px-5">
        <div className="flex flex-col md:grid md:grid-cols-5 md:gap-10 md:items-center">
          {/* 모바일: 제목 먼저 */}
          <div className="block md:hidden mb-6">
            <div className="mb-3">
              <span className="text-[#222222] font-semibold text-xs tracking-[0.2em] uppercase">CONTACT US</span>
            </div>
            <h2 className="text-xl font-bold text-[#222222]">KW테크</h2>
          </div>

          <div className="md:col-span-3 mb-6 md:mb-0">
            <div className="w-full h-[250px] md:h-[380px] rounded-lg overflow-hidden shadow-lg relative">
              <iframe
                src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=경기도+오산시+서동로+65번길+60&zoom=17&language=ko"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="KW테크 위치"
              ></iframe>
            </div>
          </div>

          <div className="md:col-span-2 md:pl-6">
            {/* PC: 제목 */}
            <div className="hidden md:block mb-5">
              <span className="text-[#222222] font-semibold text-sm tracking-[0.2em] uppercase">CONTACT US</span>
            </div>
            <h2 className="hidden md:block text-3xl font-bold text-[#222222] mb-8">KW테크</h2>

            <div className="space-y-4 md:space-y-5">
              {/* 주소 - PC/모바일 모두 표시 */}
              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-9 h-9 md:w-10 md:h-10 bg-primary-light rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-primary text-sm md:text-base"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-[#222222] mb-1 text-xs md:text-sm">주소</h4>
                  <p className="text-sm md:text-base text-[#222222]">경기도 오산시 서동로 65번길 60</p>
                </div>
              </div>

              {/* 담당자 - PC만 표시 */}
              <div className="hidden md:flex items-start gap-4">
                <div className="w-10 h-10 bg-primary-light rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-user-line text-primary text-base"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-[#222222] mb-1 text-sm">담당자</h4>
                  <p className="text-base text-[#222222]">오현근 대표</p>
                </div>
              </div>

              {/* 이메일 - PC만 표시 */}
              <div className="hidden md:flex items-start gap-4">
                <div className="w-10 h-10 bg-primary-light rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-primary text-base"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-[#222222] mb-1 text-sm">이메일</h4>
                  <a
                    href="mailto:mania2004@hanmail.net"
                    className="text-base text-primary hover:text-primary-dark transition-colors cursor-pointer"
                  >
                    mania2004@hanmail.net
                  </a>
                </div>
              </div>

              {/* 전화 - PC만 표시 */}
              <div className="hidden md:flex items-start gap-4">
                <div className="w-10 h-10 bg-primary-light rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-primary text-base"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-[#222222] mb-1 text-sm">전화</h4>
                  <p className="text-base text-[#222222]">031-377-4524</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
